import React from "react";
import {
  BorderWrapper,
  CommentMarkdown,
  CommentWrapper,
} from "./__styles__/Comment";

export interface CommentProps {
  content: string;
  truncate: boolean;
}

const Comment = ({ content, truncate }: CommentProps) => {
  return (
    <CommentWrapper>
      <BorderWrapper truncate={truncate}>
        <CommentMarkdown
          markdown={content}
          truncate={truncate}
          options={{ simpleLineBreaks: true }}
        />
      </BorderWrapper>
    </CommentWrapper>
  );
};

export default Comment;
